import cn from 'classnames';
import { Choices } from './Choices';
import { IsBoolChoice, IsInline } from 'helpers';
import { Question } from './Question';
import { QuestionDropdown } from './QuestionDropdown';
import { QuestionProps, QuestionType } from 'types';

export function QuestionContent(props: QuestionProps) {
	const { choices, isSubquestion = false, questionType, subQuestions, testId } = props;
	const isBoolChoice = IsBoolChoice(choices);
	const inline = IsInline(choices);
	const isDropdown = isSubquestion && !isBoolChoice && QuestionType.RadioMatrix === questionType;
	return (
		<div className={cn({ inline, row: !inline, 'text-left': isBoolChoice })}>
			{isDropdown ? (
				<QuestionDropdown {...props} />
			) : (
				<>
					<Choices {...props} />
					{subQuestions.map(q => (
						<Question {...q} isSubquestion key={q.id} testId={testId} />
					))}
				</>
			)}
		</div>
	);
}
